import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=7c0ffc95&scoped=true&"
import script from "./ValidateEmail.vue?vue&type=script&lang=js&"
export * from "./ValidateEmail.vue?vue&type=script&lang=js&"
import style0 from "./ValidateEmail.vue?vue&type=style&index=0&id=7c0ffc95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0ffc95",
  null
  
)

export default component.exports